import React from "react";
import { Link } from "react-router-dom";
import EditProfile from "../../components/AdminDashboard/EditProfile";

const EditProfilePage = () => {
  return (
    <>
      {/* Breadcrumb */}
      <div className="breadcrumb-card">
        <h5>Profile</h5>

        <ul className="breadcrumb">
          <li>
            <Link to="/">
              <i className="material-symbols-outlined">home</i>
              Home
            </Link>
          </li>
          <li>Edit Profile</li>
        </ul>
      </div>

      {/* Content goes here */}
      <div className="user-management-content">
        {/* Placeholder for Edit Profile component */}
        <EditProfile />
      </div>
    </>
  );
};

export default EditProfilePage;

